import { createApiClient } from './client'
export { API_URL, setApiStatusHandler } from './client'
export const $apiJSON = createApiClient()
export default $apiJSON
